import { render, staticRenderFns } from "./ActivitiesModal.vue?vue&type=template&id=2d84db42&scoped=true&"
import script from "./ActivitiesModal.vue?vue&type=script&lang=js&"
export * from "./ActivitiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesModal.vue?vue&type=style&index=0&id=2d84db42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84db42",
  null
  
)

export default component.exports